module.exports = __webpack_public_path__ + "48d7647256f95da5b398fa75037f0762.svg";